export const MAX_HISTORY_LENGTH = 20;
export const WAITING_MESSAGE_TIME = 3 * 1000;
export const WAITING_MESSAGE_TIME_LONG = 25 * 1000;
export const TIMEOUT_ERROR_TIME = 45 * 1000;
export const DEFAULT_FINN_SERVER = 'wss://hello-finn.herokuapp.com/';

export const INTERNAL_USER_COOKIE_VALUE =
  'fancier-bustard-trope-warring-nuisance';

export const PRIMER_QUESTIONS = [
  'Why is /transactions/sync/ better than /get?',
  'What is Remember Me?',
  "What's the difference between an Item and an access token?",
  'How do I set up a webhook for IDV?',
  "What's the difference between Plaid Identity and IDV?",
  'Can you show code for getting transactions in Python?',
  'Which countries does Investments support?',
  'How do I fix an Item in ITEM_LOGIN_REQUIRED state?',
  'Can you show code for getting real-time balance in Node?',
  'How do I enable IDV selfie checks?',
  'Do access tokens expire?',
  'How do I set up Link on the web?',
  'Can you show code for getting a credit card APR in Ruby?',
];

export const WAITING_MESSAGES = [
  'Hang tight! Bill is coming up with the perfect answer.',
  'Hang tight! Bill is double-checking his math.',
  'Reticulating splines...',
  'Hold on tight! Bill is warming up his brain.',
  'One moment, Bill is thinking.',
  'One moment! Bill is crafting the perfect answer just for you.',
  "One second! We'll have an answer soon.",
  "One moment. Bill said you were his favorite developer, so he's taking some time to make sure your answer is perfect.",
  'Your answer is being handcrafted by a semi-aquatic, egg-laying mammal. Please allow extra time.',
  "One moment. Bill is doing that thing where he stares into the void. It's all part of the process.",
  "We'd play hold music here, but musical licenses are expensive. So please hum quietly to yourself.",
  'One moment. Turns one 1 second in human time is, like, 7 in platypus time.',
  "One sec: Bill is putting his thinking cap on. It's oddly shaped but effective.",
  "(Fun fact: Bill was originally named 'Finn'.)",
  '(Fun fact: The platypus is one of only five mammals that lay eggs!)',
  "(Fun fact: Platypuses have venomous spurs on their hind legs. So don't sneak up on them.)",
  "(Fun fact: The plural of 'platypus' is either 'platypus' or 'platypuses', not 'platypi'.)",
  '(Fun fact: When the platypus was first discovered, scientists thought it was a hoax.)',
  '(Fun fact: Platypuses glow under ultraviolet light, and nobody knows why.)',
  '(Fun fact: A group of platypuses is known as a "paddle".)',
  'One moment. Bill is electrolocating your answer.',
  'Loading clever loading message...',
  'Thinking extra hard...',
  '(Fun fact: The platypus can hold its breath for up to 11 minutes.)',
  "(Fun fact: The platypus is Plaid's unofficial mascot, in spite of the fact that they don't typically use fintech products.)",
];
